"use client";

import { useEffect, useState } from "react";

import { detectCurrentWebPushCapability, type WebPushCapability } from "@/lib/web-push-browser";

export function useCurrentWebPushCapability() {
  const [capability, setCapability] = useState<WebPushCapability | null>(null);

  useEffect(() => {
    setCapability(detectCurrentWebPushCapability());
  }, []);

  return capability;
}
